import { memo } from 'react';
import { Dialog, DialogContent, IconButton, Box } from '@mui/material';
import { Close, Download } from '@mui/icons-material';

interface MediaLightboxProps {
  open: boolean;
  onClose: () => void;
  src: string;
  type: 'image' | 'video';
  alt?: string;
}

function MediaLightbox({ open, onClose, src, type, alt }: MediaLightboxProps) {
  const handleDownload = () => {
    const a = document.createElement('a');
    a.href = src;
    a.download = type === 'video' ? 'video.mp4' : 'image.png';
    a.target = '_blank';
    a.click();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          bgcolor: 'rgba(0,0,0,0.95)',
          maxWidth: '95vw',
          maxHeight: '95vh',
          m: 1,
          overflow: 'hidden',
        },
      }}
    >
      <Box sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1, display: 'flex', gap: 0.5 }}>
        <IconButton onClick={handleDownload} sx={{ color: 'white', bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }} size="small">
          <Download fontSize="small" />
        </IconButton>
        <IconButton onClick={onClose} sx={{ color: 'white', bgcolor: 'rgba(255,255,255,0.1)', '&:hover': { bgcolor: 'rgba(255,255,255,0.2)' } }} size="small">
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent sx={{ p: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {type === 'video' ? (
          <video
            src={src}
            controls
            autoPlay
            style={{ maxWidth: '90vw', maxHeight: '85vh', outline: 'none' }}
          />
        ) : (
          <img
            src={src}
            alt={alt || 'Preview'}
            style={{ maxWidth: '90vw', maxHeight: '85vh', objectFit: 'contain' }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}

export default memo(MediaLightbox);
